import {
  Box,
  InputAdornment,
  Skeleton,
  Grid,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { ReactComponent as DollarIcon } from '../../../../../../assets/dollar.svg';
import { ReactComponent as BoxIcon } from '../../../../../../assets/box.svg';
import { ReactComponent as NoImage } from '../../../../../../assets/no-image.svg';

import BackButton from '../../../../../../components/shared/BackButton';
import CustomCard from '../../../../../../components/shared/CustomCard';
import InfiniteScroll from 'react-infinite-scroll-component';

const SubCategoryMenuMobile = (props) => {
  const {
    theme,
    // *-------
    roadHirarki,
    setRoadHirarki,
    // *--- page
    setPage,
    setSubCategoryMenu,
    // *--- table
    tableSearch,
    setTableSearch,
    tableTotalItems,
    tableDatas,
    // *-date & time
    timeFrame,
    setTimeFrame,
    dateRange,
    setDateRange,
    saveDateRange,
    setSaveDateRange,
    // *--- Handler
    handleBackButton,
    handleClickName,
    handleClickRow,
    handleAdd,
  } = props;

  return (
    <Grid container columns={12} spacing={2}>
      <Grid
        item
        xs={12}
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <BackButton handleClick={handleBackButton} />
        <Typography
          sx={{
            ml: '4px',
            fontSize: '16px',
            fontWeight: '600',
            color: '#9E9D9D',
            cursor: 'pointer',
          }}
          onClick={handleBackButton}
        >
          Category
        </Typography>
        <ChevronRightIcon sx={{ color: '#9E9D9D' }} />
        <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>
          {roadHirarki.category}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CustomCard sx={{ p: '12px' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {/* JUDUl */}
              <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>
                Subcategory
              </Typography>
              <TextField
                placeholder={'Search'}
                size="small"
                sx={{
                  width: '100px',
                  height: '20px',
                  '.MuiOutlinedInput-input': {
                    padding: '6px 0px 6px 0px',
                    fontSize: '0.5rem',
                  },
                  '.MuiOutlinedInput-root': {
                    bgcolor: '#FAFAFA',
                    borderRadius: '4px',
                  },
                }}
                value={tableSearch}
                onChange={(e) => setTableSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ width: '8px', ml: '4px' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                flexDirection: 'row-reverse',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '4px',
                  bgcolor: theme.palette.primary.main,
                  width: '20px',
                  height: '20px ',
                  cursor: 'pointer',
                }}
                onClick={handleAdd}
              >
                <AddIcon sx={{ color: 'white', width: '8px', height: '8px' }} />
              </Box>
              <CustomCard
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '4px',
                  width: '20px',
                  height: '20px ',
                }}
              >
                <FilterAltIcon sx={{ width: '12px' }} />
              </CustomCard>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: '16px',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <DollarIcon style={{ height: '10px' }} />
                <Typography sx={{ fontSize: '8px' }}>COGS(Rp)*</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <BoxIcon style={{ height: '10px' }} />
                <Typography sx={{ fontSize: '8px' }}>SKU</Typography>
              </Box>
            </Box>
            <Typography sx={{ fontSize: '8px' }}>*000</Typography>
          </Box>
          <Box sx={{}}>
            <InfiniteScroll
              dataLength={tableTotalItems}
              next={() => {}}
              hasMore={true}
              loader={<Skeleton variant="text" sx={{ mt: 1 }} />}
              style={{
                marginTop: '8px',
                maxHeight: '243px',
                overflow: 'auto',
              }}
            >
              <Grid container columns={12} sx={{}} spacing={'16px'}>
                {/* ITEMSS */}
                {tableDatas.map((data, index) => (
                  <Grid
                    item
                    xs={6}
                    key={index}
                    onClick={(e) =>
                      handleClickRow(data.subkategori, data.idSubkategori)
                    }
                  >
                    <Box
                      sx={{
                        bgcolor: '#FAFAFA',
                        p: '8px',
                        borderRadius: '8px',
                        height: '65px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        // handleClickRow(data.namaKategori, data.idKategori);
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* Photo */}
                        <Box
                          onClick={(event) =>
                            handleClickName(
                              event,
                              data.subkategori,
                              data.idSubkategori
                            )
                          }
                        >
                          {!data.gbrsub ? (
                            <Box
                              sx={{
                                width: '28px',
                                height: '28px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                bgcolor: '#FAFAFA',
                                borderRadius: '2px',
                              }}
                            >
                              <NoImage />
                              <Typography
                                sx={{ color: '#9E9D9D', fontSize: '4px' }}
                              >
                                No photo
                              </Typography>
                            </Box>
                          ) : (
                            <Box>
                              <img
                                src={
                                  process.env.REACT_APP_API_IMAGE_BASE_URL +
                                  '/' +
                                  data.gbrsub.split(',')[0]
                                }
                                style={{
                                  width: '28px',
                                  height: '28px',
                                  borderRadius: '2px',
                                }}
                              />
                            </Box>
                          )}
                        </Box>
                        {/* Title */}
                        <Box sx={{ ml: '8px' }}>
                          <Typography
                            sx={{
                              fontSize: '8px',
                              fontWeight: '600',
                              color: '#848589',
                            }}
                          >
                            {!data.subsidiary ? '-' : data.subsidiary.name}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '10px',
                              fontWeight: '600',
                              mt: '2px',
                            }}
                            onClick={(event) =>
                              handleClickName(
                                event,
                                data.subkategori,
                                data.idSubkategori
                              )
                            }
                          >
                            {data.subkategori}
                          </Typography>
                        </Box>
                      </Box>
                      {/* ITEMSS */}
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mt: '8px',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                          }}
                        >
                          <DollarIcon style={{ height: '8px' }} />
                          <Typography sx={{ fontSize: '8px' }}>
                            {data.productsSumHarga
                              ? data.productsSumHarga
                              : '-'}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                          }}
                        >
                          <BoxIcon style={{ height: '8px' }} />
                          <Typography sx={{ fontSize: '8px' }}>
                            {data.productsCount ? data.productsCount : '-'}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </InfiniteScroll>
          </Box>
        </CustomCard>
      </Grid>
    </Grid>
  );
};

export default SubCategoryMenuMobile;
